import React from 'react';
import { Typography, Stack, Chip } from '@mui/material';
import CandidateSection from './CandidateSection';

const CandidateSkills = ({ skills }) => (
    <CandidateSection title="Skills">
        {skills?.length > 0 ? (
            <Stack direction="row" flexWrap="wrap" gap={1}>
                {skills.map((skill) => (
                    <Chip
                        key={skill.id}
                        label={skill.title}
                        sx={{ bgcolor: '#f1f5f9', color: 'text.primary', fontWeight: 500, height: 28 }}
                    />
                ))}
            </Stack>
        ) : (
            <Typography variant="body2" color="text.secondary">No skills listed</Typography>
        )}
    </CandidateSection>
);

export default CandidateSkills;
